import { render } from "./LessonCoverContentComponent.vue?vue&type=template&id=4745249a&scoped=true"
import script from "./LessonCoverContentComponent.vue?vue&type=script&lang=js"
export * from "./LessonCoverContentComponent.vue?vue&type=script&lang=js"

import "./LessonCoverContentComponent.vue?vue&type=style&index=0&id=4745249a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4745249a"]])

export default __exports__